<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <ik-data-table
    ref="table"
    entity-name="repertory"
    :model="model"
    icon="mdi-label"
    style="width: 100%"
    @reloaded="reloaded"
  />
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import DCacheProperty from '@/model/dataLayer/api/restaurant/DCacheProperty'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: DCacheProperty
    })
  },
  methods: {
    reloaded () {
    }
  }
}
</script>

<style scoped>

</style>
